(ns quuppa.date
  "Simple IEquiv and IComparable extensions to some js-joda objects"
  (:require ["@js-joda/core" :refer [LocalDate ZonedDateTime Instant]]))

;; Js-joda equals methods check the other value is of same type.

(extend-type LocalDate
  IEquiv
  (-equiv [date other]
    (.equals ^js/Object date other))
  IComparable
  (-compare [date other]
    (.compareTo ^js/Object date other)))

(extend-type ZonedDateTime
  IEquiv
  (-equiv [date other]
    (.equals date other))
  IComparable
  (-compare [date other]
    (.compareTo date other)))

(extend-type Instant
  IEquiv
  (-equiv [date other]
    (.equals date other))
  IComparable
  (-compare [date other]
    (.compareTo date other)))
